import { Route, Routes, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import Career from './pages/Career';
import Contact from './pages/Contact';
import CorpSocialResponsibility from './pages/CorpSocialResponsibility';
import './App.scss'
import NotFound from './pages/NotFound';
import About from './pages/About';
import IndustryPage from './pages/IndustryPage';
import ServicePage from './pages/ServicePage';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Training from './pages/TrainingPage';
import TalentEnable from './pages/TalentEnable';
import NearShore from './pages/NearShoreService';
import { AnimatePresence } from 'motion/react';
import GalleryPage from './pages/GalleryPage';
import GccSetup from './pages/GccSetup';
import ExecutiveSearch from './pages/ExecutiveSearch';



function App() {

  const location = useLocation();

  return (
    <>
    <AnimatePresence initial={false} mode='wait'>
    <Routes location={location} key={location?.pathname}>
        <Route index path='/' element={<Home />} />
        <Route  path='/career' element={<Career />} />
        <Route  path='/contact' element={<Contact/>} />
        <Route  path='/services/:name' element={<ServicePage/>} />
        <Route  path='/services/training' element={<Training/>} />
        <Route  path='/services/talent' element={<TalentEnable/>} />
         <Route  path='/services/gcc-setup' element={<GccSetup/>} />
         <Route  path='/services/executive-search' element={<ExecutiveSearch/>} />

        <Route  path='/services/nearshore' element={<NearShore/>} />
        <Route  path='/corp-social-responsibility' element={<CorpSocialResponsibility/>} />
        <Route  path='/about' element={<About />} />
        <Route  path='/gallery' element={<GalleryPage />} />
        <Route  path='/industries/:name' element={<IndustryPage />} />
        <Route  path='/privacy-policy' element={<PrivacyPolicy />} />
        <Route  path='*' element={<NotFound />} />
    </Routes>   
    </AnimatePresence>
    </>
  );
}

export default App;
